/**
 * Builds a 24-entry by-hour array from segments of [untilHour, value].
 * Example: [[6, 48], [12, 60], [24, 52]] → 48 for hours 0–5, 60 for 6–11, 52 for 12–23.
 */
export const byHourSegments = (segments: [untilHour: number, value: number][]): number[] =>
  Array.from({ length: 24 }, (_, hour) => {
    const segment = segments.find(([untilHour]) => hour < untilHour) ?? segments[segments.length - 1];
    return segment[1];
  });

export const CLEAR_SKY: number[] = byHourSegments([[24, 1]]);
